import { render, staticRenderFns } from "./UploadedFiles.vue?vue&type=template&id=3b98bd52&scoped=true&"
import script from "./UploadedFiles.vue?vue&type=script&lang=js&"
export * from "./UploadedFiles.vue?vue&type=script&lang=js&"
import style0 from "./UploadedFiles.vue?vue&type=style&index=0&id=3b98bd52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b98bd52",
  null
  
)

export default component.exports